<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        Enter Custom Percent
      </v-card-title>
      <v-card-text class="mt-3 body-2">
        <div>
          <v-text-field
            dense
            v-model="updateData.amount"
            type="number"
            placeholder="Percent"
            outlined
            @input="$v.updateData.amount.$touch()"
            :error-messages="$v.updateData.amount.$error && !isAdmins ? `Amount is required.` : ''"
            @blur="$v.updateData.amount.$touch()"
          ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="saveCustomAmount" :disabled="$v.updateData.$invalid">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators';
// import moment from 'moment'
import Loading from 'vue-loading-overlay';
export default {
  name: 'PayoutUpdateModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    dealData: Object
  },
  mixins: [validationMixin],
  validations: function() {
    const validationRules = {
      updateData: {
        amount: { required }
      }
    }
    return validationRules
  },
  data () {
    return {
      isLoading: false,
      updateData: {
        amount: ''
      }
    }
  },
  async mounted() {
  },
  watch: {
    value: function(newValue) {
      this.updateData = {
        amount: ''
      }
    }
  },
  methods: {
    async saveCustomAmount() {
      this.$v.$touch()
      let newDealData = Object.assign({}, this.dealData)
      newDealData.amount = this.updateData.amount
      this.$emit('addedAmount', newDealData)
      this.close()
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// CustomAmountUpdateModal.vue?06580d0b